import { getCurrentInstance } from "vue";
/**
 * @description vue router 3.6.5 버전 + vue 2.7 script setup에서 사용하기 위한 대체 코드
 * 헬퍼를 쓰는 것보다 간단하고 vue-router/composables은 불안정하다는 이야기가 있어 instance를 사용하였음
 */
export function useRouter() {
    const instance = getCurrentInstance();
    const proxy = instance?.proxy;
    return proxy.$router;
}
